import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Cards1 from './../block/Cards1'
import ShortInfo from './../block/ShortInfo'
import TipiLesnic from './../block/TipiLesnic'
import DelaemLesnici from './../block/DelaemLesnici'
import Kviz from './../block/Kviz'
import Dekoraciya from './../block/Dekoraciya'
import DerevoKlassA from './../block/DerevoKlassA'
import VnsshniyVid from './../block/VnsshniyVid'
import VnimanieKDetalam from './../block/VnimanieKDetalam'
import TipiKarkasov from './../block/TipiKarkasov'
import Podarok from './../block/Podarok'

import Raschet from './../block/Raschet'

import Kontakti from './../block/Kontakti'

class Lestnici extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <VnsshniyVid
          data={data?.vnsshniyvid}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.lesnici_list || []}
          title={data?.lesnici_title || ``}
          rtext={data?.lesnici_rtext || ``}
          margin={`top`}
          cols={`2`}
          bg={`2`}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
          hide_subtitle={true}
          margin={`top-10`}
        />
        <TipiLesnic
          list={data?.lesnici_types}
        />
        <DelaemLesnici
          list={data?.delaemlesnici || []}
        />
        <Kviz
          data={data?.kviz || []}
          assets_path={assets_path}
        />
        <Dekoraciya
          data={data?.dekoraciya || []}
        />
        <TipiLesnic
          title={`Наши <span>кейсы и фотосеты</span>`}
          rtext={`[Изготавливаем сложные конструкции]`}
          list={data?.lesnici_fotoseti}
          margin={`bottom-50`}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <DerevoKlassA
          data={data?.derevoklassa}
          margin={`top-50-botom-10`}
          bg={`2`}
        />
        <Cards1
          list={data?.derevoklassa?.list || []}
          margin={`bottom`}
          cols={`4`}
          layout={2}
        />
        <VnimanieKDetalam
          list={data?.vnimaniekdetalam?.list || []}
          title={data?.vnimaniekdetalam?.title || ``}
          rtext={data?.vnimaniekdetalam?.rtext || ``}
          img1={data?.vnimaniekdetalam?.img1 || ``}
          img2={data?.vnimaniekdetalam?.img2 || ``}
        />
        <TipiKarkasov
          list={data?.tipikarkasov?.list || []}
          title={data?.tipikarkasov?.title || ``}
          rtext={data?.tipikarkasov?.rtext || ``}
          text={data?.tipikarkasov?.text || ``}
        />
        <Cards1
          list={data?.preimlesnic?.list || []}
          title={data?.preimlesnic?.title || ``}
          rtext={data?.preimlesnic?.rtext || ``}
          margin={`y`}
          cols={`3`}
          bg={`2`}
        />
        <Podarok
          data={data?.podarok || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Cards1
          list={data?.nashmontaz?.list || []}
          title={data?.nashmontaz?.title || ``}
          rtext={data?.nashmontaz?.rtext || ``}
          margin={`top`}
          cols={`1`}
          bg={`1`}
          layout={3}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

Lestnici.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Lestnici.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Lestnici